<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>修改密码</div>
      </div>
      <div class="card-body">
        <el-form label-width="120px">
          <el-form-item :label="$t('changeStaffPwd.oldPassword')">
            <el-input v-model="changeStaffPwdInfo.oldPwd" type="password"
              :placeholder="$t('changeStaffPwd.oldPasswordPlaceholder')" show-password></el-input>
          </el-form-item>
          <el-form-item :label="$t('changeStaffPwd.newPassword')">
            <el-input v-model="changeStaffPwdInfo.newPwd" type="password"
              :placeholder="$t('changeStaffPwd.newPasswordPlaceholder')" show-password></el-input>
          </el-form-item>
          <el-form-item :label="$t('changeStaffPwd.confirmPassword')">
            <el-input v-model="changeStaffPwdInfo.reNewPwd" type="password"
              :placeholder="$t('changeStaffPwd.confirmPasswordPlaceholder')" show-password></el-input>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="text-right">
      <el-button type="primary" @click="handleChangePwd" style="margin-top: 10px;">
        {{ $t('changeStaffPwd.confirmChange') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { changeStaffPwd } from '@/api/frame/changeStaffPwdApi'

export default {
  name: 'ChangeStaffPwd',
  data() {
    return {
      changeStaffPwdInfo: {
        oldPwd: '',
        newPwd: '',
        reNewPwd: ''
      }
    }
  },
  methods: {
    validateForm() {
      if (!this.changeStaffPwdInfo.oldPwd) {
        this.$message.error(this.$t('changeStaffPwd.oldPasswordRequired'))
        return false
      }
      if (!this.changeStaffPwdInfo.newPwd) {
        this.$message.error(this.$t('changeStaffPwd.newPasswordRequired'))
        return false
      }
      if (!this.changeStaffPwdInfo.reNewPwd) {
        this.$message.error(this.$t('changeStaffPwd.confirmPasswordRequired'))
        return false
      }
      if (this.changeStaffPwdInfo.newPwd !== this.changeStaffPwdInfo.reNewPwd) {
        this.$message.error(this.$t('changeStaffPwd.passwordNotMatch'))
        return false
      }
      return true
    },
    async handleChangePwd() {
      if (!this.validateForm()) return

      try {
        const res = await changeStaffPwd(this.changeStaffPwdInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('changeStaffPwd.changeSuccess'))
          this.changeStaffPwdInfo = {
            oldPwd: '',
            newPwd: '',
            reNewPwd: ''
          }
          this.$router.push('/views/frame/login')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

.card-body {
  padding: 20px;
}
</style>